import {
  FromButton,
  OrganizationForm,
  OrganizationSection,
  PopoverSection,
  SubTitle,
  SubTitleNumber,
  SubTitleText,
  TooltipBox,
} from "./EditProfileStyle";
import {
  Button,
  Col,
  Form,
  Image,
  OverlayTrigger,
  Popover,
  Row,
} from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import ToolIcon from "../../../assests/images/component.svg";
import { MESSAGE } from "../../../utils/message";
import { useFormik } from "formik";
import * as Yup from "yup";
import { REGEX } from "../../../utils/constant";
import { OrganizationProfileProps } from "../../../utils/types";
import { useSelector, useDispatch } from "react-redux";
import { editNonprofitProfileHandler } from "../../../redux/slices/myNonprofit/editnonprofit-slice";
import { useParams } from "react-router-dom";

const popover = (
  <PopoverSection>
    <Popover className="popover-basic">
      <Popover.Body>
        Click for the full list of NTEE classification by code.
      </Popover.Body>
    </Popover>
  </PopoverSection>
);


const OrganizationProfile = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const editNonprofitProfileSlice: any = useSelector((state: any) => state?.editNonprofitProfile);
  const nonprofitProfile: any = useSelector((state: any) => state?.editNonprofitProfile?.data?.results);
  const states: any = useSelector(
    (state: any) => state?.editNonprofitProfile?.states?.results
  );

  const countries: any = useSelector(
    (state: any) => state?.editNonprofitProfile?.countries?.results
  );
  const issues: any = useSelector(
    (state: any) => state?.editNonprofitProfile?.issues?.results
  );

  const handleSelect = (selectedList: string[], selectedItem: any) => {
    if (selectedList.length > 4) {
      // Remove the last added item to keep the selection within the limit
      selectedList.pop();
    }
    if (selectedList.length <= 4) {
      formik.setFieldValue("ntees", selectedList);
    }
  };

  const handleRemove = (selectedList: string[]) => {
    formik.setFieldValue("ntees", selectedList);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: nonprofitProfile?.title || "",
      ntees: nonprofitProfile?.ntees || [],
      address1: nonprofitProfile?.address1 || "",
      city: nonprofitProfile?.city || "",
      state: nonprofitProfile?.state || "",
      state_full: nonprofitProfile?.state_full || "",
      zipcode: nonprofitProfile?.zipcode || "",
      country: nonprofitProfile?.country || "",
      org_email: nonprofitProfile?.org_email || "",
      website: nonprofitProfile?.website || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().trim().required(MESSAGE.requiredErrors("Organization Name")),
      ntees: Yup.array()
        .min(1, "At least one issue must be selected")
        .required(MESSAGE.requiredErrors("ntees")),
      address1: Yup.string().trim().required(MESSAGE.requiredErrors("Street Address")),
      city: Yup.string().trim().required(MESSAGE.requiredErrors("City")),
      state: Yup.string().trim().required(MESSAGE.requiredErrors("State")),
      zipcode: Yup.string().trim().required(MESSAGE.requiredErrors("Zip")),
      country: Yup.string().trim().required(MESSAGE.requiredErrors("Country")),
      org_email: Yup.string().trim()
        .matches(REGEX.emailValidate, {
          message: MESSAGE.invalidErrors(MESSAGE.emailLabel),
          excludeEmptyString: true,
        })
        .max(50, MESSAGE.maxLengthErrors(MESSAGE.emailLabel, 50))
        .required(MESSAGE.requiredErrors(MESSAGE.emailLabel)),
      website: Yup.string().trim().required(MESSAGE.requiredErrors("Website link")),
    }),
    onSubmit: (values: OrganizationProfileProps) => {
      if (id) {
        dispatch(editNonprofitProfileHandler(id, values) as any)
      }
    },
  });


  return (
    <OrganizationSection>
      <SubTitle>
        <SubTitleNumber>01</SubTitleNumber>
        <SubTitleText>{MESSAGE.yourOrganization}</SubTitleText>
      </SubTitle>
      <OrganizationForm onSubmit={formik.handleSubmit}>
        <Row>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                value={formik.values.title}
                name="title"
                onChange={formik.handleChange}
              />
              {formik.touched.title && formik.errors.title && (
                <div className="error">
                  <p>{formik.errors.title}</p>
                </div>
              )}
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>

            <Form.Group>
              <TooltipBox>
                <Form.Label>Issues (Maximum of 4 issues)</Form.Label>
                <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement="bottom"
                  overlay={popover}
                >
                  <Button className="tooltipBtn">
                    <Image src={ToolIcon} alt="ToolIcon" />
                  </Button>
                </OverlayTrigger>
              </TooltipBox>

              <Multiselect
                options={Array.isArray(issues) ? issues : []}
                selectedValues={formik.values.ntees}
                onSelect={handleSelect}
                onRemove={handleRemove}
                displayValue="title"
                customCloseIcon={true}
                hidePlaceholder={true}
                placeholder="Select up to 4 issues"
                showCheckbox
              // disable={formik.values.ntees.length >= 4}
              />



              {formik.touched.ntees && formik.errors.ntees && (
                <div className="error">
                  <p>{formik.errors.ntees}</p>
                </div>
              )}
            </Form.Group>

          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>{MESSAGE.streetAddress}</Form.Label>
              <Form.Control
                type="text"
                value={formik.values.address1}
                name="address1"
                onChange={formik.handleChange}
              />
              {formik.touched.address1 && formik.errors.address1 && (
                <div className="error">
                  <p>{formik.errors.address1}</p>
                </div>
              )}
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>{MESSAGE.city}</Form.Label>
              <Form.Control
                type="text"
                value={formik.values.city}
                name="city"
                onChange={formik.handleChange}
              />
              {formik.touched.city && formik.errors.city && (
                <div className="error">
                  <p>{formik.errors.city}</p>
                </div>
              )}
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Label>{MESSAGE.state}</Form.Label>
            <Form.Select
              size="lg"
              name="state"
              value={formik.values.state}
              defaultValue={formik.values.state}
              onChange={(e) => {
                const selectedState = e.target.value;
                formik.setFieldValue("state", selectedState);

                const stateDetails = states?.find((item: any) => item.state === selectedState);
                if (stateDetails) {
                  formik.setFieldValue("state_full", stateDetails.name);
                } else {
                  formik.setFieldValue("state_full", "");
                }
              }}
            >
              <option value="">----Select----</option>
              {Array.isArray(states) && states.map((item) => (
                <option key={item.id} value={item.state}>{item.name}</option>
              ))}
            </Form.Select>

            {formik.touched.state && formik.errors.state && (
              <div className="error state-error">
                <p>{formik.errors.state}</p>
              </div>
            )}
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>{MESSAGE.zip}</Form.Label>
              <Form.Control
                type="text"
                value={formik.values.zipcode}
                name="zipcode"
                onChange={formik.handleChange}
              />
              {formik.touched.zipcode && formik.errors.zipcode && (
                <div className="error">
                  <p>{formik.errors.zipcode}</p>
                </div>
              )}
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Label>Country</Form.Label>
            <Form.Select
              size="lg"
              name="country"
              value={formik.values.country}
              onChange={formik.handleChange}
            >
              <option>----Select----</option>
              {Array.isArray(countries) && countries?.map(item => (
                <option key={item?.id} value={item?.country}>{item?.country}</option>
              ))}
            </Form.Select>
            {formik.touched.country && formik.errors.country && (
              <div className="error state-error">
                <p>{formik.errors.country}</p>
              </div>
            )}
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-form-group">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Email"
                id="org_email"
                value={formik.values.org_email}
                onChange={formik.handleChange}
              />
            </Form.Group>
            {formik.touched.org_email && formik.errors.org_email && (
              <div className="error">
                <p>{formik.errors.org_email}</p>
              </div>
            )}
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box website-link-box">
              <Form.Label>{MESSAGE.website}</Form.Label>
              <Form.Control
                type="text"
                value={formik.values.website}
                name="website"
                onChange={formik.handleChange}
              />
              {formik.touched.website && formik.errors.website && (
                <div className="error">
                  <p>{formik.errors.website}</p>
                </div>
              )}
            </Form.Group>
          </Col>
          <FromButton>
            <Button
              type="submit"
              className="btn-outline-success-blue"
            >
              {MESSAGE.saveChanges}
              {editNonprofitProfileSlice?.isLoading && <span className="btnloader"></span>}
            </Button>
          </FromButton>
        </Row>
      </OrganizationForm>
    </OrganizationSection>
  );
};

export default OrganizationProfile;
